<c11n-modal-dialog-entrypoint></c11n-modal-dialog-entrypoint>
<div class="vgn-container default-padding" *ngIf="!isPolarisDataLoaded">
  <no-data-page [noDataCaas]="noData"></no-data-page>
</div>
<div class="vgn-container default-padding" *ngIf="isPolarisDataLoaded">
    <h1 class="mt-4 c11n-text-3xl-headline c11n-space-stack-8x">{{ fd3ContentGenericListResponse.title }}</h1>
    <div *ngIf="caasContent !== undefined">
      <fd3-filters></fd3-filters>
      <div class="fund-details-wrapper tab-padding mobile-view-order" *ngIf="searchFilter.filterInitialized && isPolarisDataLoaded">
        <div class="check-filter-benchmark--wrapper flex-item-second" *ngIf="isFundLiteratureContentValueFetch">
          <sort-by-type [fd3tableContentList]="fd3tableContentList"></sort-by-type>
        </div>
        <div class="fund-details-tab-wrapper" *ngIf="isFundLiteratureContentValueFetch">
          <view-type [isFundLiteratureNoData]="noData" [fd3tableContentList]="fd3tableContentList" [viewType]="viewType"
                     [fundLiteratureContentServiceError]="fundLiteratureContentServiceError"></view-type>
        </div>
        <div class="performance-table-spinner d-flex align-items-center justify-content-center" *ngIf="!isFundLiteratureContentValueFetch">
          <c11n-spinner [size]="'medium'" [colorMode]="'on-light'" [spinnerStatus]="'Loading...'"></c11n-spinner>
        </div>
        <fd3-page-footnote [footNoteCaas]="footNoteCaas"></fd3-page-footnote>
      </div>
    </div>
  </div>
